/*
 *
 * OLDER VERSION STORE WITHOUT GLOBAL RESETTING STATE FUNXTIONALITY ==================================================>
 * 
 */

// import { configureStore } from "@reduxjs/toolkit";
// import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import createOrderSlice from "./slices/createOrderSlice";
// import authSlice from "./slices/authSlice";

// import threadSlice from "./slices/threadSlice";

// const persistConfigThread = {
//     key: 'thread',
//     storage: storage,
//     version: 1,
// };

// const persistedThreadReducer = persistReducer(persistConfigThread, threadSlice);

// export const store = configureStore({
//     reducer: {
//         auth: authSlice,
//         thread: persistedThreadReducer,
//         createOrder: createOrderSlice
//     },
//     middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
// });

// export const persistor = persistStore(store);
// export * from "./slices/createOrderSlice";
// export * from "./slices/threadSlice";
// export * from "./thunks/threadThunk";
// export * from "./thunks/orderThunk";
// export * from "./slices/authSlice";
// export * from './thunks/authThunks';

/*
 *
 * NEW VERSION STORE WITH GLOBAL RESETTING STATE FUNXTIONALITY ==============================================================>
 * 
 */

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createOrderSlice from "./slices/createOrderSlice";
import authSlice from "./slices/authSlice";
import threadSlice from "./slices/threadSlice";
import userSlice from "./slices/userSlice";

const persistConfigThread = {
    key: 'thread',
    storage: storage,
    version: 1,
};

const persistedThreadReducer = persistReducer(persistConfigThread, threadSlice);

const persistConfigAuth = {
  key: "auth",
  storage: storage,
  version: 1,
};

const persistedAuthReducer = persistReducer(persistConfigAuth, authSlice);

const appReducer = combineReducers({
    auth: persistedAuthReducer,
    thread: persistedThreadReducer,
    createOrder: createOrderSlice,
    user: userSlice
});

const rootReducer = (state, action) => {
    if (action.type === 'reset') {
        state = undefined;
    }
    return appReducer(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);
export * from "./slices/createOrderSlice";
export * from "./slices/threadSlice";
export * from "./thunks/threadThunk";
export * from "./thunks/orderThunk";
export * from "./slices/authSlice";
export * from './thunks/authThunks';
export * from "./slices/userSlice";
export * from "./thunks/userThunk";